import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import type { ReactNode } from "react";

/**
 * AppProviders — общие провайдеры витрины. Ретраи выключены: ShopGuard сам решает,
 * что показать при ошибке бутстрапа, и сам вызывает повтор по кнопке «Повторить».
 * Пока в витрине один запрос (бутстрап) — общего обработчика ошибок TanStack Query
 * не заводим: он получит смысл, когда появится второй потребитель (docs/09 §1.2).
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [client] = useState(
    () => new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
